import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor(private translate: TranslateService) {  
        if(localStorage.getItem('language')){
            translate.setDefaultLang(localStorage.getItem('language'));
        }else{
            translate.setDefaultLang('am');
        }
    }
}
